import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'first-project';

  myCarinfo = [{
    
    
    'name':"maruti",
    'stock':4,
    'discriptions':"This is Aswosome product 3 take",
    Price:5000
  },
  
  {
  
  'name':"Papu",
  'stock':12,
  'discriptions':"This is Aswosome product 2",
  'Price':200
  },
  {
    
    'name':"Papu",
    'stock':12,
    'discriptions':"This is Aswosome product 2",
    'Price':1500
    },

  {
    
    'name':"maruti",
    'stock':4,
    'discriptions':"This is Aswosome product 3 ",
    'Price':703
  },
  {
    
    'name':"maruti",
    'stock':4,
    'discriptions':"This is Aswosome product 3 ",
    'Price':800
  },
  {
    
    'name':"maruti",
    'stock':4,
    'discriptions':"This is Aswosome product 3 ",
    Price:100
  

  }];
       totalMobile(){
 
let sum=0;
   for( let mobpart of this.myCarinfo)
   {
     sum += sum++;
   }
   return sum;

       }
  

}
